import {Button} from '@primer/react'
import type {ComponentPropsWithRef} from 'react'

export type ActionBarTriggerProps = Omit<ComponentPropsWithRef<typeof Button>, 'as' | 'size' | 'variant'>

export function ActionBarTrigger({ref, ...props}: ActionBarTriggerProps) {
  return <Button {...props} ref={ref} size="small" variant="default" />
}

ActionBarTrigger.displayName = 'ActionBarTrigger'
